import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/module/carousel.css";

// import bg4 from "../../assets/images/img/bg-4.webp";

const slides = [
  {
    title: "Requirements and Analysis",
    desc: "We start by identifying your system needs, integration goals, and reviewing existing infrastructure to ensure compatibility with third-party or internal APIs.",
  },
  {
    title: "Integration Planning",
    desc: "After the analysis, we map out a clear integration strategy—defining endpoints, data flow, authentication methods, and choosing the right tools and protocols.",
  },
  {
    title: "System Design",
    desc: "We design how the systems will communicate—structuring requests, responses, and error handling to ensure seamless data exchange and performance.",
  },
  {
    title: "Development and Integration",
    desc: "Our developers implement the integration by connecting APIs, writing logic, and building middleware that ensures your systems work together efficiently.",
  },
  {
    title: "Testing and Validation",
    desc: "We rigorously test the integrated systems for accuracy, security, performance, and reliability—making sure data flows correctly across platforms.",
  },
  {
    title: "Deployment",
    desc: "Once testing is complete, we roll out the integration in your live environment with minimal disruption to existing systems or services.",
  },
  {
    title: "Monitoring and Maintenance",
    desc: "Post-deployment, we continuously monitor the integration, apply updates, fix issues, and ensure it stays aligned with any API changes or scaling needs.",
  },
];

export default function APISlider() {
  useScrollReveal("slide-from-left");
  useScrollReveal("drop-from-top");
  useScrollReveal("slide-from-bottom");
  const settings = {
    dots: true, // Show dots
    infinite: false, // Do not loop infinitely
    speed: 500, // Slide animation speed
    slidesToShow: 3, // Show 3 slides at once
    slidesToScroll: 1, // Scroll one slide at a time
    swipeToSlide: true, // Allow drag/swipe
    arrows: false, // Show arrows
    responsive: [
      // Responsive settings for smaller screens
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div id="karuzela" className="section section__carousel">
      {/* <img
        className="container-bg image-background left slide-from-left"
        src={bg4}
        alt="container background"
        style={{ marginTop: "400px" }}
      /> */}
      <div className="container carousel">
        <h5 className="drop-from-top">step by step</h5>
        <div className="title flex drop-from-top">
          <h2 style={{ marginBottom: 30 }}>
            What does the API & System Integration process look like?
          </h2>
        </div>

        <div className="carousel-slider slick-initialized slick-slider slick-dotted slide-from-bottom">
          <div className="slick-list draggable">
            <Slider {...settings}>
              {slides.map((slide, index) => (
                <div key={index} className="card" style={{ padding: 10 }}>
                  <div className="card-element">
                    <h6 className="title">{slide.title}</h6>
                    <span className="desc mini">{slide.desc}</span>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
}
